export default __webpack_public_path__ + "img/preview-8.6d32acf4.jpg";